<div class="two-factor-setup-modal">
  <div class="two-factor-setup-modal__header">
    <div class="two-factor-setup-modal__title component-title">
      {{ 'user-profile.security.twoFactor.title' | translate }}
    </div>
    <button mat-icon-button (click)="onCancel()" aria-label="Close">
      <app-icon class="two-factor-setup-modal__cross-icon" [icon]="iconName.CROSS" />
    </button>
  </div>

  <div class="two-factor-setup-modal__content">
    @if (isDownloadStep()) {
      <div
        class="two-factor-download-step__instruction"
        [innerHTML]="
          'user-profile.security.twoFactor.steps.download.instruction'
            | translate
              : {
                  appName: ('user-profile.security.twoFactor.steps.download.appName' | translate),
                  downloadLink:
                    ('user-profile.security.twoFactor.steps.download.downloadLink' | translate),
                }
        "
      ></div>
    }

    @if (isScanQrStep()) {
      <div class="two-factor-scan-step step">
        <h3 class="step__title">
          {{ 'user-profile.security.twoFactor.steps.qrCode.title' | translate }}
        </h3>
        <p class="step__description">
          {{ 'user-profile.security.twoFactor.steps.qrCode.subtitle' | translate }}
        </p>

        <div class="qr-code">
          <qrcode
            [qrdata]="twoFactorData.qrCodeUri"
            [width]="160"
            [errorCorrectionLevel]="'M'"
            [elementType]="'canvas'"
          />
          <span class="qr-code__value">
            {{ formatSecretKey(twoFactorData.secretKey) }}
          </span>
        </div>
      </div>
    }

    @if (isVerifyCodeStep()) {
      <div class="two-factor-verify-step step">
        <h3 class="step__title">
          {{ 'user-profile.security.twoFactor.steps.verificationCode.title' | translate }}
        </h3>
        <p class="step__description">
          {{ 'user-profile.security.twoFactor.steps.verificationCode.subtitle' | translate }}
        </p>

        <form class="verification" [formGroup]="verificationForm">
          <div class="verification__wrapper">
            <div class="verification__input-container" formArrayName="code">
              @for (control of codeArray.controls; track $index) {
                <input
                  id="code-{{ $index }}"
                  type="text"
                  maxlength="1"
                  class="verification__input"
                  [class.error]="showInvalidCodeError()"
                  [formControlName]="$index"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  (input)="onInput($event, $index)"
                  (keydown)="onKeyDown($event, $index)"
                />
              }
            </div>
            @if (showInvalidCodeError()) {
              <span class="verification__error">
                {{
                  'user-profile.security.twoFactor.steps.verificationCode.errorMessage' | translate
                }}
              </span>
            }
          </div>
        </form>
      </div>
    }
  </div>

  <div class="two-factor-setup-modal__actions">
    @if (showBackButton()) {
      <button
        class="two-factor-setup-modal__button two-factor-setup-modal__button--back"
        (click)="onBack()"
      >
        {{ 'user-profile.security.actionButtons.back' | translate }}
      </button>
    } @else {
      <button
        class="two-factor-setup-modal__button two-factor-setup-modal__button--cancel"
        (click)="onCancel()"
      >
        {{ 'user-profile.security.actionButtons.cancel' | translate }}
      </button>
    }

    <button
      class="two-factor-setup-modal__button two-factor-setup-modal__button--next"
      [disabled]="isNextButtonDisabled()"
      (click)="nextStep()"
    >
      {{ 'user-profile.security.actionButtons.next' | translate }}
    </button>
  </div>
</div>
